import { inputWithOptionsDriverFactory } from '../InputWithOptions/InputWithOptions.driver';
import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const searchDriverFactory = args => {
  deprecationTestkitLog(
    'searchTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the SearchTestkit unidriver testkit instead.',
  );
  const { element } = args;

  const inputWithOptionsDriver = inputWithOptionsDriverFactory({
    ...args,
    element:
      element && element.querySelector('[data-hook="search-inputwithoptions"]'),
  });

  return {
    ...inputWithOptionsDriver,
    driver: {
      ...inputWithOptionsDriver.driver,
      isExpandable: () => element.hasAttribute('data-expandable'),
      isCollapsed: () => element.hasAttribute('data-collapsed'),
    },
  };
};

export { searchDriverFactory };
